/**
 * Public runtime configuration, read once from `import.meta.env`.
 * Everything here is bundled into the browser: only the API URL, the brand name, the auth
 * mode and Supabase's public anon key belong here. Never add a secret.
 */
export type AuthMode = 'supabase' | 'dev';

export interface AppConfig {
  apiUrl: string;
  brandName: string;
  authMode: AuthMode;
  supabaseUrl: string;
  supabaseAnonKey: string;
  devOrgId: string;
  devUser: string;
}

export function readConfig(env: ImportMetaEnv): AppConfig {
  return {
    apiUrl: (env.VITE_API_URL ?? '').replace(/\/+$/, ''),
    brandName: env.VITE_BRAND_NAME || 'PrepAI',
    // The bypass must be asked for explicitly; anything else means Supabase.
    authMode: env.VITE_AUTH_MODE === 'dev' ? 'dev' : 'supabase',
    supabaseUrl: env.VITE_SUPABASE_URL ?? '',
    supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY ?? '',
    devOrgId: env.VITE_DEV_ORG_ID || 'default',
    devUser: env.VITE_DEV_USER || 'Developer',
  };
}

export const config: AppConfig = readConfig(import.meta.env);
